import { listingCoverImage } from "./fileUrl";

export const PARKING_FALLBACK =
  "https://images.unsplash.com/photo-1506521781263-d8422e82f27a?auto=format&fit=crop&w=1200&q=80";

const PLACEHOLDER_HINT = "1506521781263";

export function isParkingPlaceholderUrl(url) {
  if (!url) return false;
  const s = String(url);
  return s.includes("images.unsplash.com") && s.includes(PLACEHOLDER_HINT);
}

/** Host-facing hint when photos are absent or only a stock placeholder is shown. */
export function parkingPhotoStatus(spot) {
  const images = spot?.images || [];
  if (images.length === 0) return { missing: true, placeholder: false };
  const first = images[0];
  if (isParkingPlaceholderUrl(first)) return { missing: false, placeholder: true };
  const resolved = listingCoverImage(images, "");
  if (isParkingPlaceholderUrl(resolved)) return { missing: false, placeholder: true };
  return null;
}

export function parkingPhotoEditPath(spotId) {
  return `/host?tab=parking&spot_id=${encodeURIComponent(spotId)}&photos=1`;
}

export function parkingPatchPayload(spot, images) {
  return {
    name: spot.name,
    address: spot.address,
    city: spot.city,
    space_type: spot.space_type || "driveway",
    price_per_hour: spot.price_per_hour,
    daily_max: spot.daily_max ?? null,
    max_hours: spot.max_hours ?? null,
    open_24_7: !!spot.open_24_7,
    open_time: spot.open_time || null,
    close_time: spot.close_time || null,
    facilities: spot.facilities || [],
    description: spot.description || "",
    images,
  };
}
